import { Svg } from "../svg";
import { IconType } from "../../models";

export const IconClose: IconType = ({ className = "" }) => (
  <Svg className={className} viewBox="0 0 20 20">
    <line
      x1="0.75"
      y1="-0.75"
      x2="24.3304"
      y2="-0.75"
      transform="matrix(-0.719455 0.694539 -0.719455 -0.694539 18.4531 0.840332)"
      stroke="#F8F7F6"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <line
      x1="0.75"
      y1="-0.75"
      x2="24.3304"
      y2="-0.75"
      transform="matrix(0.719455 0.694539 -0.719455 0.694539 0.463135 1.97119)"
      stroke="#F8F7F6"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </Svg>
);
